import { gql, QueryHookOptions, useQuery } from '@apollo/client';

export const useQueryImportLogs = (
  options?: QueryHookOptions<ImportLogsData, ImportLogsVariables>,
) => useQuery<ImportLogsData, ImportLogsVariables>(IMPORT_LOGS, options);

export const IMPORT_LOGS = gql`
  query importLogs($importer: String, $dateFrom: String) {
    importLogs {
      items(importer: $importer, dateFrom: $dateFrom) {
        id
        importer
        file
        parsedCount
        importedCount
        errorItemsCount
        createdAt
      }
    }
  }
`;

export type ImportLogsVariables = {
  importer?: string;
  dateFrom?: string;
};

export type ImportLogsData = {
  importLogs: { items: ImportLogItem[] };
};

export type ImportLogItem = {
  id: string;
  importer: string;
  file: string;
  parsedCount: number;
  importedCount: number;
  errorItemsCount: number;
  createdAt: string;
};
